const LogoType = (light, logo, darkLogo) => (light ? darkLogo || logo : logo)

export default LogoType
